export default __webpack_public_path__ + "411f0866e5072cc5a34ca1c8134124b6.png";